import { createUtilityClasses } from './createUtilityClasses';

export const classes = createUtilityClasses(['order']);
